import React, { useState } from "react";
import { ModalLabel, ModalTitle, Modal, Button } from "./PocketMoneyModal.style";
import { useNavigate } from "react-router";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { ErrorModal } from "@components";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AvailableModal from "../AvailableModal/AvailableModal";
import ExpiredModal from "../ExpiredModal/ExpiredModal";

const PocketMoneyModal = ({ isOpen, setIsOpen, pocket_money_id }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [openAvailable, setOpenAvailable] = useState(false);
  const [resultTransactions, setResultTransactions] = useState([]);
  const [open, setOpen] = useState(false);
  const [apiMessage, setApiMessage] = useState('');

  const { user } = useSelector((state) => state.auth);

  const handleClicked = () => {
    setLoading(true);

    api
      .postCheckPocketMoney({
        pocket_money_id,
      })
      .then(({ transactions, is_available, message }) => {
        setLoading(false);
        setIsOpen(false);
        if (is_available) {
          navigate(`/${PUBLIC_ROUTE.POCKET_MONEY_CONFIRM_PIN}`, {
            state: {
              pocket_money_id,
            },
          });
        } else {
          setResultTransactions(transactions || []);
          if (message) {
            setApiMessage(message);
            setOpen(true);
          }
          else {
            setOpenAvailable(true);
          }
        }
      })
      .catch((errorMsg) => {
        setLoading(false);
        setError(errorMsg);
        setIsOpen(false);
        setIsOpenError(true);
      });
  };

  const availableCallback = () => {
    setOpenAvailable(false);
    setOpen(false);
    if (resultTransactions.length > 0) {
      const findPocketMoney = resultTransactions.find(
        (transaction) => transaction.created_by === user.user_id
      );
      const amount = findPocketMoney ? findPocketMoney.amount : 0;

      navigate(`/${PUBLIC_ROUTE.POCKET_MONEY}`, {
        state: {
          transactions: resultTransactions,
          amount,
        },
      });
    }
  };

  return (
    <>
      <Modal
        open={isOpen}
        closable={false}
        footer={null}
        style={{
          textAlign: "center",
        }}
        centered={true}
        onCancel={() => {
          setIsOpen(false);
        }}
        width={365}
        height={423}
      >
        <ModalTitle>{t("pocketMoney.pocketMoneyTitle")}</ModalTitle>
        <ModalLabel>{t("pocketMoney.pocketMoneySubtitle")}</ModalLabel>
        <Button
          type="primary"
          onClick={handleClicked}
          loading={loading}
        >
          {t("common.ok")}
        </Button>
      </Modal>
      <AvailableModal
        open={openAvailable}
        onOk={availableCallback}
      />
      <ExpiredModal
        open={open}
        message={apiMessage}
        onOk={availableCallback}
      />
      <ErrorModal
        open={isOpenError}
        onOk={() => {
          setIsOpenError(false);
        }}
        label={error}
        title={t("pocketMoney.pocketMoneyTitle")}
      />
    </>
  );
};

export default PocketMoneyModal;
